import { UIImage } from "../ui/common_ui_elements/ui_image.js";
import { AvatarUtils } from "./avatar_utils.js";
import { loadFacebookAvatar } from "./facebook_avatar_loader.js";

export interface StoredAvatar
{
  avatar_id: number;
  facebook_avatar_url: string | null;
}

export function readStoredAvatar( default_id = 0 ): StoredAvatar
{
  const raw = Number.parseInt( localStorage.getItem( 'player_avatar_id' ) ?? '', 10 );
  return {
    avatar_id: Number.isFinite( raw ) ? raw : default_id,
    facebook_avatar_url: localStorage.getItem( 'player_facebook_avatar_url' ),
  };
}

export class AvatarImageBinder
{
  private shown_id: number = Number.NaN;
  private shown_url: string | null = null;

  constructor( private readonly image: UIImage, private readonly on_photo_applied?: () => void ) {}

  public apply( avatar_id: number, facebook_avatar_url: string | null ): boolean
  {
    if ( avatar_id === this.shown_id && facebook_avatar_url === this.shown_url )
      return false;

    this.shown_id = avatar_id;
    this.shown_url = facebook_avatar_url;
    this.image.setImageId( AvatarUtils.getAvatarImgId( avatar_id ) );

    if ( avatar_id === AvatarUtils.FACEBOOK_AVATAR_ID && facebook_avatar_url )
    {
      const url = facebook_avatar_url;
      loadFacebookAvatar( url )
        .then( bitmap =>
        {
          if ( this.shown_id !== AvatarUtils.FACEBOOK_AVATAR_ID || this.shown_url !== url )
            return;
          this.image.setImageBitmap( bitmap );
          this.image.forceRedraw();
          this.on_photo_applied?.();
        } )
        .catch( () => {} );
    }
    return true;
  }

  public applyFromStorage( default_id = 0 ): boolean
  {
    const stored = readStoredAvatar( default_id );
    return this.apply( stored.avatar_id, stored.facebook_avatar_url );
  }
}
